/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `R10EditaceDti` - R10 editace DTI
 *   * `R12EditujZps` - R12 edituj ZPS
 *   * `R16PrijmiGadAzi` - R16 prijmi GAD AZI
 *   * `R16PrijmiGadDtmk` - R16 prijmi GAD DTMK
 *   * `R16PrijmiGadEditoraZps` - R16 prijmi GAD editora ZPS
 *   * `R16PrijmiGadVsp` - R16 prijmi GAD VSP
 * ```
 */
export const PrejimkaDmvsSourceEnum = {
  R10EditaceDti: 'R10EditaceDti',
  R12EditujZps: 'R12EditujZps',
  R16PrijmiGadAzi: 'R16PrijmiGadAzi',
  R16PrijmiGadDtmk: 'R16PrijmiGadDtmk',
  R16PrijmiGadEditoraZps: 'R16PrijmiGadEditoraZps',
  R16PrijmiGadVsp: 'R16PrijmiGadVsp',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PrejimkaDmvsSourceEnum = ValuesOf<typeof PrejimkaDmvsSourceEnum>;

export type PrejimkaDmvsSourceEnumRequest = PrejimkaDmvsSourceEnum;
export type PrejimkaDmvsSourceEnumResponse = PrejimkaDmvsSourceEnum;
